<main class="content" *ngIf="stepStatus > 3">
  <div class="image-container">
    <img src="/assets/images/grow-intro.png" [alt]="" />
  </div>
  <div class="text-container">
    <h1 class="ds-title-1 header">{{ 'account.grow.downloadApp.title' | translate }}</h1>
    <p class="ds-running-1">{{ 'account.grow.downloadApp.description' | translate }}</p>
    <div class="badge-container">
      <a href="{{ appLinks.playStore }}" class="link-playStore" target="_blank"
        ><img src="{{ playStoreBadgeSource }}" alt="Get it on Google Play"
      /></a>
      <a href="{{ appLinks.appStore }}" class="link-appleStore" target="_blank"
        ><img src="{{ appleStoreBadgeSource }}" alt="Download on the Apple Store"
      /></a>
    </div>
  </div>
</main>
